import apiClient from './apiClient';

const authService = {
    /**
     * Paso 1: Verificar usuario y obtener empresas asociadas
     * @param {string} email - Correo electrónico del usuario
     * @returns {Promise<Object>} - Datos del usuario y lista de empresas
     */
    checkUser: async (email) => {
        const response = await apiClient.post('/auth/check-user', { email });
        return response; // Devuelve { user_id, username, email, companies: [...] }
    },

    /**
     * Paso 2: Iniciar sesión con empresa seleccionada
     * @param {Object} credentials - { user_id, company_id, password }
     * @returns {Promise<Object>} - Token y datos de sesión
     */
    login: async ({ user_id, company_id, password }) => {
        const response = await apiClient.post('/auth/login', {
            user_id,
            company_id,
            password
        });
        return response; // Devuelve { token, user, company }
    },

    /**
     * Cerrar sesión
     */
    logout: async () => {
        return apiClient.post('/auth/logout');
    },

    /**
     * Obtener usuario actual
     */
    getCurrentUser: async () => {
        // Nota: Endpoint hipotético basado en convención, verificar si existe en Swagger o usar token decode
        return apiClient.get('/auth/me');
    },

    /**
     * Refrescar token
     */
    refreshToken: async () => {
        return apiClient.post('/auth/refresh');
    }
};

export default authService;
